module.exports = __webpack_public_path__ + "img/show-qr-code.450ef38c.svg";